import{ useState } from 'react';
import { placess, act, office } from '../../../data/data'
import { useTranslation } from 'react-i18next';
import {
    ArrowDropDown, Email,
    FileUpload, MessageOutlined,
    PersonOutline, Phone
}
    from '@mui/icons-material';


const Juridical = ({
    data, setData,
    // handlePost,
    // isLoading
}) => {
    const { t } = useTranslation();
    const [showVelayatDropdown, setShowVelayatDropdown] = useState(false);
    const [showEtrapDropdown, setShowEtrapDropdown] = useState(false);
    const [showActDropdown, setShowActDropdown] = useState(false);
    const [showPlacesDropdown, setShowPlacesDropdown] = useState(false);
    const [etrapOptions, setEtrapOptions] = useState([]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setData({ ...data, attachment: file ? file : null});
    };
    
    const handlePhoneNumberChange = (e) => {
        let input = e.target.value;
        if (!input.startsWith('+993')) {
            input = '+993' + input.replace(/[^0-9]/g, '');
        } else {
            input = '+993' + input.slice(4).replace(/[^0-9]/g, '');
        }
        if (input.length > 12) {
            input = input.slice(0, 12);
        }
        setData({ ...data, phone_number: input });
    };

    const handleVelayatSelect = (velayat) => {
        setData({ ...data, province: velayat.title, district: ''});
        setEtrapOptions(velayat.content);
        setShowVelayatDropdown(false);
    };

    const handleEtrapSelect = (etrap) => {
        setData({ ...data, district: etrap.name });
        setShowEtrapDropdown(false);
    };

    const handleActSelect = (act) => {
        setData({ ...data, act: act.name });
        setShowActDropdown(false);
    };

    const handlePlaceSelect = (office) => {
        setData({ ...data, places: office.name });
        setShowPlacesDropdown(false);
    };

    // const buttonColor = 
    //       !data.province || 
    //       !data.district || 
    //       !data.act || 
    //       !data.first_name || 
    //       !data.last_name || 
    //       !data.patronimic || 
    //       !data.email || 
    //       !data.message || 
    //       !data.phone_number ? 
    //       'bg-primary' : 'bg-green';


    // useEffect(() => {
    //     if (data.requester_type === 'organization') {
    //         handlePost(new Event('submit'));
    //     }
    // }, [data.requester_type]);

    // const handleRequesterPost = () => {
    //     setData({
    //         ...data,
    //         requester_type: 'organization',
    //     });
    //     if (!data.province || !data.district || !data.act || !data.first_name || !data.last_name || !data.patronimic || !data.email || !data.message || !data.phone_number || !data.organization_name) {
    //         alert(t('all_must'));
    //     } else {
    //         alert(t('appeal_success'));
    //     }
    // };

    return (
        <form>
            {/* zero row */}
            <div className="mb-4 lg:flex justify-between gap-8">
                <div className="w-full relative mt-4 lg:mt-0">
                    <input
                        type="text"
                        name="institution_name"
                        value={data.organization_name}
                        onChange={(e) => setData({ ...data, organization_name: e.target.value })}
                        placeholder={t('institution_name')}
                        className="px-4 py-2 border border-border 
                                   bg-secondary rounded w-full mt-1
                                   focus:outline-none focus:ring-2 mb-2
                                   focus:ring-indigo-500 dark:text-white 
                                   dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
            </div>

            {/* first row */}
            <div className="mb-4 mt-6 lg:flex justify-between gap-8">
                {/* Velayat Selection */}
                <div className="lg:w-[50%] relative">
                    <div className='relative'>
                        <input
                            type="text"
                            name="velayat"
                            value={data.province}
                            placeholder={t('select_province')}
                            readOnly
                            className="w-full px-4 py-2 border border-border rounded 
                                   bg-secondary dark:bg-dark-box dark:border-dark-border 
                                   focus:outline-none focus:ring-2 mb-2 cursor-pointer
                                   focus:ring-indigo-500 dark:text-white "
                            onClick={() => setShowVelayatDropdown(!showVelayatDropdown)}
                        />
                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                                       text-blackOpacity dark:text-dark-text"
                        />
                    </div>
                    {showVelayatDropdown && (
                        <div className="absolute top-full mt-[-7px] left-0 w-full bg-white 
                                    border z-10 max-h-64 overflow-y-auto
                                    dark:bg-dark-box shadow-lg  border-secondary
                                    dark:border-dark-border dark:text-dark-text
                                    p-2 rounded-md input-table">
                            {placess.map((velayat) => (
                                <div
                                    key={velayat.id}
                                    onClick={() => handleVelayatSelect(velayat)}
                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                >
                                    {velayat.title}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Etrap Selection */}
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <div className='relative'>
                        <input
                            type="text"
                            name="etrap"
                            value={data.district}
                            placeholder={t('select_county')}
                            readOnly
                            className="w-full px-4 py-2 border border-border 
                                   bg-secondary rounded cursor-pointer
                                   focus:outline-none focus:ring-2 mb-2
                                   focus:ring-indigo-500 dark:text-white 
                                   dark:bg-dark-box dark:border-dark-border"
                            onClick={() => data.province &&
                                setShowEtrapDropdown(!showEtrapDropdown)
                            }
                        />
                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                                       text-blackOpacity dark:text-dark-text"
                        />
                    </div>
                    {showEtrapDropdown && (
                        <div className="absolute top-full mt-[-7px] left-0 w-full bg-white 
                                    border z-10 max-h-64 overflow-y-auto
                                    dark:bg-dark-box shadow-lg  border-secondary
                                    dark:border-dark-border dark:text-dark-text
                                    p-2 rounded-md input-table">
                            {etrapOptions.map((etrap, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleEtrapSelect(etrap)}
                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                >
                                    {etrap.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* second row */}
            <div className="mb-4 lg:flex justify-between gap-8">
                {/* Name Input */}
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <PersonOutline style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('write_name')}
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={data.first_name}
                        onChange={e => setData({ ...data, first_name: e.target.value })}
                        placeholder={t('write_name')}
                        className="w-full px-4 py-2 border mt-1 mb-2
                                  border-border bg-secondary rounded
                                  focus:outline-none focus:ring-2 
                                  focus:ring-indigo-500 dark:text-white 
                                  dark:bg-dark-box dark:border-dark-border"
                    />
                </div>

                {/* Surname Input */}
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <PersonOutline style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('write_surname')}
                    </label>
                    <input
                        type="text"
                        name="surname"
                        value={data.last_name}
                        onChange={(e) => setData({ ...data, last_name: e.target.value })}
                        placeholder={t('write_surname')}
                        className="px-4 py-2 border border-border 
                                   bg-secondary rounded w-full mt-1
                                   focus:outline-none focus:ring-2 mb-2
                                   focus:ring-indigo-500 dark:text-white 
                                   dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
            </div>

            {/* third row */}
            <div className="mb-4 lg:flex justify-between gap-8">

                {/* Third-name Input */}
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <PersonOutline style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('write_patronymic')}
                    </label>
                    <input
                        type="text"
                        name="third_name"
                        placeholder={t('write_patronymic')}
                        value={data.patronimic}
                        onChange={(e) => setData({ ...data, patronimic: e.target.value })}
                        className="w-full px-4 py-2 border mt-1
                                  border-border bg-secondary mb-2
                                  rounded  focus:outline-none focus:ring-2 
                                  focus:ring-indigo-500 dark:text-white 
                                  dark:bg-dark-box dark:border-dark-border"
                    />
                </div>

                {/* Email Input */}
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <Email style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('Email')}
                    </label>
                    <input
                        type="text"
                        name="email"
                        placeholder={t('Email')}
                        value={data.email}
                        onChange={(e) => setData({ ...data, email: e.target.value })}
                        className="px-4 py-2 border border-border 
                                   bg-secondary rounded w-full mt-1
                                   focus:outline-none focus:ring-2 mb-2
                                   focus:ring-indigo-500 dark:text-white 
                                   dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
            </div>


            {/* four row */}
            <div className="mb-4 lg:flex justify-between gap-8">

                {/* Places Selection */}
                <div className="lg:w-[50%] relative">
                    <div className='relative'>
                        <input
                            type="text"
                            name="velayat"
                            value={data.places}
                            placeholder={t('select_category')}
                            readOnly
                            className="w-full px-4 py-2 border border-border rounded 
                                       bg-secondary dark:bg-dark-box dark:border-dark-border 
                                       focus:outline-none focus:ring-2 mb-2 cursor-pointer
                                       focus:ring-indigo-500 dark:text-white mt-1"
                            onClick={() => setShowPlacesDropdown(!showPlacesDropdown)}
                        />
                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                                       text-blackOpacity dark:text-dark-text"
                        />
                    </div>
                    {showPlacesDropdown && (
                        <div className="absolute top-full mt-[-7px] left-0 w-full bg-white 
                                        border z-10 max-h-64 overflow-y-auto
                                        dark:bg-dark-box shadow-lg  border-secondary
                                        dark:border-dark-border dark:text-dark-text
                                        p-2 rounded-md input-table">
                            {office.map((office) => (
                                <div
                                    key={office.id}
                                    onClick={() => handlePlaceSelect(office)}
                                    className="px-4 py-2 hover:bg-secondary cursor-pointer"
                                >
                                    {office.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Act Selection */}
                <div className="lg:w-[50%] relative">
                    <div className="relative">
                        <input
                            type="text"
                            name="act"
                            value={data.act}
                            placeholder={t('select_type')}
                            readOnly
                            className="w-full px-4 py-2 border border-border bg-secondary
                                       rounded cursor-pointer focus:outline-none 
                                       focus:ring-2 focus:ring-indigo-500 mt-1 mb-2
                                       dark:bg-dark-box dark:border-dark-border"
                            onClick={() => setShowActDropdown(!showActDropdown)}
                        />
                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                                       text-blackOpacity dark:text-dark-text"
                        />
                    </div>
                    {showActDropdown && (
                        <div className="absolute top-full mt-[-7px] left-0 w-full 
                                    border z-10 max-h-64 overflow-y-auto bg-white 
                                    dark:bg-dark-box shadow-lg  border-secondary
                                    dark:border-dark-border dark:text-dark-text
                                    p-2 rounded-md input-table">
                            {act.map((act) => (
                                <div
                                    key={act.id}
                                    onClick={() => handleActSelect(act)}
                                    className="px-4 py-2 hover:bg-secondary 
                                               dark:hover:text-dark cursor-pointer"
                                >
                                    {act.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* fifth row */}
            <div className="mb-4">
                <label className='flex items-center gap-1 text-sm
                                  dark:text-dark-text mt-6'>
                    <MessageOutlined style={{ fontSize: '18px', color: '#0039a6' }} />
                    {t('your_message')}
                </label>
                <textarea
                    type="text"
                    name="email"
                    placeholder={t('your_message')}
                    value={data.message}
                    onChange={(e) => setData({ ...data, message: e.target.value })}
                    className="px-4 py-2 border border-border mt-1
                               h-40 bg-secondary rounded w-full 
                               focus:outline-none focus:ring-2 mb-2
                               focus:ring-indigo-500 dark:text-white 
                               dark:bg-dark-box dark:border-dark-border"
                />
            </div>

            {/* six row */}
            <div className="mb-4 lg:flex justify-between gap-8 items-end">
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <div className='text-sm text-dark-border 
                                    dark:text-dark-text'>
                        {t('attach_file')} :
                        (doc, docx, jpg, pdf, rtf, txt, odt, zip, rar,
                        png, tiff, jpeg, mp4, avi, mov, mp3, wav)
                    </div>

                    <input
                        type="file"
                        id="file-upload"
                        className="hidden"
                        onChange={handleFileChange}
                    />
                    <label
                        htmlFor="file-upload"
                        className="w-max flex items-center justify-center 
                                   px-4 py-2 bg-indigo-600 text-white mt-2
                                   rounded-md shadow-md cursor-pointer 
                                   transition-all duration-300 bg-primary"
                    >
                        <FileUpload className="mr-2" />
                        {t('choose_file')}
                    </label>

                    {data.attachment &&
                        <div className="mt-2 text-sm text-dark-border
                                        dark:text-dark-text">
                            {t('chosen')} : {data.attachment}
                        </div>
                    }
                </div>

                <div className="lg:w-[40%] relative mt-6 lg:mt-0">
                    <label className='flex items-center gap-1 text-sm
                                      dark:text-dark-text'>
                        <Phone style={{ fontSize: '18px', color: '#0039a6' }} />
                        {t('phone_number')}
                    </label>
                    <input
                        type="text"
                        name="phone"
                        placeholder={t('phone_number')}
                        value={data.phone_number}
                        onChange={handlePhoneNumberChange}
                        className="w-full px-4 py-2 border dark:text-dark-text
                                  border-border bg-secondary mb-2 mt-1 rounded
                                   focus:outline-none focus:ring-2 focus:ring-indigo-500 
                                  dark:bg-dark-box dark:border-dark-border"
                    />
                </div>
            </div>

            <div className='w-full flex'>
                <button
                    type="button"
                    className={`bg-secondary text-text px-6
                                py-2 mt-8 rounded ml-auto`}
                    // onClick={() => {
                    //     handleRequesterPost();
                    // }}
                >
                    {t('send')}
                </button>
            </div>
        </form>
    );
};

export default Juridical